module.exports = __webpack_public_path__ + "static/media/subject_discipline.9aff6f96.svg";